export const setEmailAccountRdx = (value: any) => {
	return {
		type: 'SET_EMAILACCOUNT',
		payload: value,
	};
};
